import {
  filter,
  flatMap,
  flow,
  get,
  map,
  replace,
  size,
  toLower,
  toNumber
} from 'lodash';

export const buildColumnId = (id) => `column-${id}`;
export const parseColumnId = (columnId) =>
  toNumber(replace(columnId, 'column-', ''));

export const buildItemId = (id) => `item-${id}`;
export const parseItemId = (itemId) => toNumber(replace(itemId, 'item-', ''));

export const getSortLabel = (sort) => get(sort, 'name', '');

export const buildSortsOptions = (sorts) =>
  map(sorts, (sort) => ({
    value: sort.id,
    label: getSortLabel(sort)
  }));

export const getNonExemplarItemsCount = (columns) =>
  flow([
    (cols) => filter(cols, ({ name }) => toLower(name) !== 'exemplar'),
    (filtered) => flatMap(filtered, 'items_order'),
    size
  ])(columns);
